module.exports = __webpack_public_path__ + "static/dumbellrattles2-6ee65e44f531564771f449f371c97cea.jpeg";